'use strict';

frontendApp.factory('ResourceTreeNode', ['$resource', 'ConfigService', 'ResourceWrapperService', function ($resource, ConfigService, ResourceWrapperService) {

  var ResourceTreeNode = $resource(ConfigService.getServerBaseUrlForResource() + '/project/:projectId/collection/:collectionId/resourceTreeNode/:id',
    {'id': '@id', 'projectId': '@projectId', 'collectionId': '@collectionId'},
    {
      'query': {method: 'GET', params: {parent: ""}, isArray: true}
    });

  return ResourceWrapperService.WrapActions(ResourceTreeNode);

}]);
